import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

enum SIZE {
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
}

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit, OnChanges {
  link: string = '';

  @Input() size: SIZE | string | undefined;
  @Input() iconName: string = '';
  @Input() fill: string = '';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() className: string = '';
  @Input() stroke: string = '';

  sizeClasses: string = '';

  ngOnInit() {
    this.setStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.iconName) {
      this.link = `/assets/svg/${this.iconName}.svg#${this.iconName}`;
      if (this.className === '') this.className = `icon-${this.iconName}`;
    }
  }

  setStyle() {
    const styles = {
      xs: 'w-3 h-3',
      sm: 'w-4 h-4',
      md: 'w-6 h-6',
      lg: 'w-8 h-8',
      xl: 'w-10 h-10',
      xxl: 'w-16 h-16',
    };

    this.sizeClasses = `${styles[this.size as SIZE]}`;
  }
}
